import { render, staticRenderFns } from "./AlertSet2.vue?vue&type=template&id=45053285&scoped=true"
import script from "./AlertSet2.vue?vue&type=script&lang=js"
export * from "./AlertSet2.vue?vue&type=script&lang=js"
import style0 from "./AlertSet2.vue?vue&type=style&index=0&id=45053285&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45053285",
  null
  
)

export default component.exports